import { render } from "./ListaEntrega.vue?vue&type=template&id=3dace5ca"
import script from "./ListaEntrega.vue?vue&type=script&lang=js"
export * from "./ListaEntrega.vue?vue&type=script&lang=js"

import "./ListaEntrega.vue?vue&type=style&index=0&id=3dace5ca&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__